const DEFAULT_REQUEST = 'default';

export default DEFAULT_REQUEST;
